import { signal } from "@preact/signals-react"

export const currenciesSignal = signal([])
export const currenciesErrorSignal = signal(null)
export const currenciesLoadedSignal = signal(false)